// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { S } from './styles';

export default function LoadingAnimation(props:React.ComponentPropsWithoutRef<'div'>): JSX.Element {
  return (
    <S.Container {...props}>
      <S.Ring></S.Ring>
    </S.Container>
  )
}
